import moment from 'moment';

const formatStart = 'MM/DD';
const formatEnd = 'MM/DD-YYYY';

export function formatExhibitionDuration({ availableFrom, availableUntil }) {
	const startDate = moment(availableFrom).format(formatStart);
	const endDate = moment(availableUntil).format(formatEnd);

	return `${startDate} - ${endDate}`;
}
